const n = (t) => Array.from({ length: 7 }, (r, a) => {
  const e = /* @__PURE__ */ new Date();
  e.setDate(e.getDate() + (a + 1) + 7 - e.getDay() % 7);
  const o = { weekday: "short" };
  return e.toLocaleDateString(t, o).slice(0, 2);
});
export {
  n as getWeekdayNames
};
